export function isMobile(): boolean {
    return __IS_MOBILE_VERSION__
}

export function isPC() {
    return !isMobile()
}
